import { useAsync } from 'react-use';
import { useUser } from '@izettle/react';
import { loadScript } from '../load-script.js';
import { getWebComponentProps } from '../utils/header-props.js';
import { jsx } from 'react/jsx-runtime';
import { useAuthClient } from '../hooks/use-auth.js';
import { useService } from '../hooks/use-service.js';
import { KnownService } from '../providers/services.js';
import { shouldLoadWebComponent } from '../utils/rest.js';

const VerticalNavigation = _ref => {
  let {
    urls,
    setReady,
    version = "latest"
  } = _ref;
  const userData = useUser();
  const authClient = useAuthClient();
  const webshopUrl = useService(KnownService.Portal);
  const portalUrl = useService(KnownService.Webshop);
  useAsync(async () => {
    if (!shouldLoadWebComponent("iz-bo-vertical-navigation")) {
      return setReady(true);
    }
    setReady(false);
    await loadScript(`https://cdn.izettle.com/components/vertical-navigation/${version}/vertical.navigation.min.js`);
    setReady(true);
  }, []);
  return /*#__PURE__*/jsx("iz-bo-vertical-navigation", {
    "use-new-header": true,
    "data-testid": "vertical-header",
    ...getWebComponentProps({
      userData,
      urls,
      isImpersonatedUser: authClient?.isImpersonatedUser,
      webshopUrl,
      portalUrl
    })
  });
};

export { VerticalNavigation };
//# sourceMappingURL=vertical-navigation.js.map
